import React, {useState} from 'react';
import {Image, Linking, ScrollView, Text, View} from 'react-native';

import {useNavigation} from '@react-navigation/native';
import ButtonComponent from '../../components/ButtonComponent/ButtonComponent';
import Header from '../../components/Header/Header';
import SearchHeader from '../../components/SearchHeader/SearchHeader';
import {Images} from '../../constants/Images';
import ModalFilter from '../Home/components/ModalFilter/ModalFilter';
import AcceptTermModal from './AcceptTerm/AcceptTermModal/AcceptTermModal';
import AcceptedTermModal from './AcceptTerm/AcceptedTermModal/AcceptedTermModal';
import {styles} from './styles';
import LinearProgress from './components/LinearProgress/LinearProgress';
import {Colors} from '../../constants/Colors';
import CircularProgress from '../Campaigns/components/CircleGraphic/CircularProgress';
import IndicatorDetails from './components/IndicatorDetails/IndicatorDetails';

const CampaignsDetails = () => {
  const {goBack} = useNavigation();
  const [filterModal, setFilterModal] = useState<boolean>(false);
  const [termModal, setTermModal] = useState<boolean>(false);
  const [acceptedTerm, setAcceptedTerm] = useState<boolean>(false);
  const [showResults, setShowResults] = useState<boolean>(false);
  const [indicatorModal, setIndicatorModal] = useState<boolean>(false);

  return (
    <ScrollView style={styles.scrollView}>
      <Header />
      <View style={styles.containerHeader}>
        <SearchHeader onPress={goBack} title="Campanhas" mb={10} />
      </View>
      <Image source={Images.cocazero} style={styles.coca} />
      <Text style={styles.campaignText}>
        Nome da campanha colocar aqui nesta linha
      </Text>
      {!showResults && (
        <>
          <View style={styles.spaceX}>
            <Text style={styles.bigDesc}>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since the 1500s, when an unknown printer took a galley of
              type and scrambled it to make a type specimen book. It has
              survived not only five centuries, but also the leap into
              electronic typesetting, remaining essentially unchanged. It was
              popularised in the 1960s with the release of Letraset sheets
              containing Lorem Ipsum passages, and more recently with desktop
              publishing software like Aldus PageMaker including versions of
              Lorem Ipsum. took a galley of type and scrambled it to make a type
              specimen book. It has survived not only five centuries, but also
              the leap into electronic typesetting, remaining essentially
              unchanged. It was popularised in the 1960s with the release of
              Letraset sheets containing Lorem Ipsum passages, and more recently
              with desktop publishing software like Aldus PageMaker including
              versions of Lorem Ipsum. five centuries, but also the leap into
              electronic typesetting, remaining essentially unchanged. It was
              popularised in the 1960s with the release of Letraset sheets
              containing Lorem Ipsum passages, and more recently with desktop
              publishing software like Aldus PageMaker including versions of
              Lorem Ipsum.
            </Text>
          </View>
          <Text style={styles.campCa}>Características da campanha</Text>
          <Text style={styles.textKit}>Kit de apoio</Text>
          <Text style={styles.kitDesc}>
            Lorem Ipsum / Lorem Ipsum / Lorem Ipsum / Lorem Ipsum / Lorem Ipsum
            / Lorem Ipsum / Lorem Ipsum / Lorem Ipsum / Lorem Ipsum / Lorem
            Ipsum / Lorem Ipsum / Lorem Ipsum / Lorem Ipsum / Lorem Ipsum /
            Lorem Ipsum.
          </Text>
          <Text style={styles.period}>Período da campanha</Text>
          <Text style={styles.dateCam}>25/10/2023 -25/10/2023</Text>
          <View style={styles.containerTermButton}>
            <ButtonComponent outlined title="Recusar Campanha" width="80%" />
            <ButtonComponent
              title="Termo de aceite"
              width="80%"
              onPress={() => setTermModal(true)}
            />
          </View>
        </>
      )}
      {showResults && (
        <View>
          <Text
            style={{
              fontSize: 16,
              lineHeight: 19,
              color: 'black',
              fontFamily: 'TCCC-UnityText Bold',
              marginTop: 50,
            }}>
            Resultados
          </Text>
          <Text
            style={{
              fontSize: 16,
              lineHeight: 19,
              color: 'black',
              fontFamily: 'TCCC-UnityText Bold',
              marginTop: 50,
              alignSelf: 'center',
            }}>
            Período vigente
          </Text>
          <Text
            style={{
              fontSize: 14,
              lineHeight: 16,
              fontFamily: 'TCCC-UnityHeadline Regular',
              color: Colors.GrayPallete.lightgrayThree,
              alignSelf: 'center',
              marginTop: 20,
            }}>
            Vigência:{' '}
            <Text style={{fontFamily: 'TCCC-UnityText Bold'}}>
              25/10/2023 - 25/10/2024
            </Text>
          </Text>
          <View
            style={{
              width: '100%',
              alignItems: 'center',
              marginTop: 30,
            }}>
            <LinearProgress />
          </View>
          <Text
            style={{
              fontSize: 16,
              lineHeight: 19,
              color: 'black',
              fontFamily: 'TCCC-UnityText Bold',
              marginTop: 50,
              alignSelf: 'center',
            }}>
            Indicadores
          </Text>
          <View
            style={{
              height: 375,
              width: '100%',
              backgroundColor: Colors.GrayPallete.lightgray,
              justifyContent: 'center',
              alignItems: 'center',
              marginTop: 40,
            }}>
            <Image
              source={Images.emptyImgIcon}
              style={{
                width: 105,
                height: 100,
              }}
            />
          </View>
          <Text
            style={{
              fontSize: 16,
              lineHeight: 19,
              color: 'black',
              fontFamily: 'TCCC-UnityText Bold',
              marginTop: 20,
              alignSelf: 'center',
            }}>
            Teste foto 2024
          </Text>
          <Text
            style={{
              fontSize: 14,
              lineHeight: 16,
              fontFamily: 'TCCC-UnityHeadline Regular',
              color: Colors.GrayPallete.lightgrayThree,
              alignSelf: 'center',
              marginTop: 10,
            }}>
            Envio pendente
          </Text>
          <View
            style={{
              width: '100%',
              alignItems: 'center',
              marginTop: 30,
            }}>
            <ButtonComponent outlined title="Detalhes" width="80%" />
          </View>
          <Text
            style={{
              fontSize: 16,
              lineHeight: 19,
              color: 'black',
              fontFamily: 'TCCC-UnityText Bold',
              marginTop: 70,
              alignSelf: 'center',
            }}>
            Teste de cobertura 2024
          </Text>
          <Text
            style={{
              fontSize: 14,
              lineHeight: 16,
              fontFamily: 'TCCC-UnityHeadline Regular',
              color: Colors.GrayPallete.lightgrayThree,
              alignSelf: 'center',
              marginTop: 10,
            }}>
            Em andamento
          </Text>
          <View
            style={{
              marginTop: 30,
            }}>
            <CircularProgress />
          </View>
          <View
            style={{
              width: '100%',
              alignItems: 'center',
              marginTop: 30,
            }}>
            <ButtonComponent
              outlined
              title="Detalhes"
              width="80%"
              onPress={() => setIndicatorModal(true)}
            />
          </View>
          <Text
            style={{
              fontSize: 16,
              lineHeight: 19,
              color: 'black',
              fontFamily: 'TCCC-UnityText Bold',
              marginTop: 70,
              alignSelf: 'center',
            }}>
            Teste de volume 2024
          </Text>
          <Text
            style={{
              fontSize: 14,
              lineHeight: 16,
              fontFamily: 'TCCC-UnityHeadline Regular',
              color: Colors.GrayPallete.lightgrayThree,
              alignSelf: 'center',
              marginTop: 10,
            }}>
            Em andamento
          </Text>
          <View
            style={{
              marginTop: 30,
            }}>
            <CircularProgress />
          </View>
          <View
            style={{
              width: '100%',
              alignItems: 'center',
              marginTop: 30,
            }}>
            <ButtonComponent
              outlined
              title="Detalhes"
              width="80%"
              onPress={() => setIndicatorModal(true)}
            />
          </View>
        </View>
      )}
      <Text style={styles.anyQuest}>Você ainda tem uma pergunta?</Text>
      <Text style={styles.contact}>
        Seu você não encontrou a sua pergunta, entre em contato com o nosso
        0800!
      </Text>
      <Text style={styles.phone} onPress={() => Linking.openURL('tel:08000615000')}>0800 061 5000</Text>
      <Text style={styles.service}>Serviço de Atendimento ao Revendedor</Text>
      <ModalFilter
        hasOrder
        hasNewCampaigns
        HasOngoingCampaigns
        onPress={() => null}
        visible={filterModal}
        onRequestClose={() => setFilterModal(false)}
      />
      <AcceptTermModal
        onPress={() => {
          setTermModal(false);
          setAcceptedTerm(true);
        }}
        onRequestClose={() => setTermModal(false)}
        visible={termModal}
      />
      <AcceptedTermModal
        onPress={() => {
          setShowResults(true);
          setAcceptedTerm(false);
        }}
        onRequestClose={() => setAcceptedTerm(false)}
        visible={acceptedTerm}
      />
      <IndicatorDetails
        onPress={() => null}
        onRequestClose={() => setIndicatorModal(false)}
        visible={indicatorModal}
      />
    </ScrollView>
  );
};

export default CampaignsDetails;
